// extracted by mini-css-extract-plugin
export default {"aside":"Sidebar_aside__1Z2Vr","asideContainer":"Sidebar_asideContainer__H8znV"};